import * as i0 from '@angular/core';
import { Directive, ViewChild, Input } from '@angular/core';
import { ControlContainer, FormControlDirective } from '@angular/forms';

class ControlValueAccessorConnectorDirective {
    constructor(injector) {
        this.injector = injector;
    }
    get control() {
        var _a, _b;
        return (this.formControl ||
            ((_b = (_a = this.controlContainer) === null || _a === void 0 ? void 0 : _a.control) === null || _b === void 0 ? void 0 : _b.get(this.formControlName)));
    }
    get controlContainer() {
        return this.injector.get(ControlContainer);
    }
    registerOnTouched(fn) {
        var _a, _b;
        (_b = (_a = this.formControlDirective) === null || _a === void 0 ? void 0 : _a.valueAccessor) === null || _b === void 0 ? void 0 : _b.registerOnTouched(fn);
    }
    registerOnChange(fn) {
        var _a, _b;
        (_b = (_a = this.formControlDirective) === null || _a === void 0 ? void 0 : _a.valueChanges) === null || _b === void 0 ? void 0 : _b.subscribe(fn);
    }
    writeValue(obj) {
        var _a, _b;
        (_b = (_a = this.formControlDirective) === null || _a === void 0 ? void 0 : _a.valueAccessor) === null || _b === void 0 ? void 0 : _b.writeValue(obj);
    }
    setDisabledState(isDisabled) {
        var _a, _b;
        // @ts-ignore: Object is possibly 'null'.
        (_b = (_a = this.formControlDirective) === null || _a === void 0 ? void 0 : _a.valueAccessor) === null || _b === void 0 ? void 0 : _b.setDisabledState(isDisabled);
    }
}
ControlValueAccessorConnectorDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.10", ngImport: i0, type: ControlValueAccessorConnectorDirective, deps: [{ token: i0.Injector }], target: i0.ɵɵFactoryTarget.Directive });
ControlValueAccessorConnectorDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.10", type: ControlValueAccessorConnectorDirective, selector: "[controlValueAccessorConnector]", inputs: { formControl: "formControl", formControlName: "formControlName" }, viewQueries: [{ propertyName: "formControlDirective", first: true, predicate: FormControlDirective, descendants: true, static: true }], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.10", ngImport: i0, type: ControlValueAccessorConnectorDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[controlValueAccessorConnector]'
                }]
        }], ctorParameters: function () { return [{ type: i0.Injector }]; }, propDecorators: { formControlDirective: [{
                type: ViewChild,
                args: [FormControlDirective, { static: true }]
            }], formControl: [{
                type: Input
            }], formControlName: [{
                type: Input
            }] } });

/**
 * Generated bundle index. Do not edit.
 */

export { ControlValueAccessorConnectorDirective };
